// src/features/agent-builder/components/steps/CraftMindStep.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { WizardStepCard } from '../WizardStepCard';
import { TextareaField } from '@dopomogai/ui';
import { FeatureTeaser } from '../teasers/FeatureTeaser';

interface CraftMindStepProps {
  personalityPrompt: string;
  onPersonalityPromptChange: (value: string) => void;
  // Make these optional for edit mode
  basicKnowledge?: string;
  onBasicKnowledgeChange?: (value:string) => void;
  isEditMode?: boolean;
}

export const CraftMindStep: React.FC<CraftMindStepProps> = (props) => {
  const { t } = useTranslation('agentBuilder');

  return (
    <>
      <WizardStepCard
        titleKey={props.isEditMode ? 'editPage.promptTitle' : 'step2.title'}
        descriptionKey={props.isEditMode ? 'editPage.promptDescription' : 'step2.description'}
        headerBgColor="bg-teal-100"
      >
        <div className="space-y-6">
          {!props.isEditMode && (
            <p className="rounded-lg border border-teal-200 bg-teal-50 px-3 py-2 text-xs text-teal-900">
              {t(
                'step2.syncHint',
                'These fields stay in sync with the onboarding assistant. Manual edits stay protected unless you explicitly confirm a replacement.',
              )}
            </p>
          )}
          <TextareaField
            label={t('step2.personality.label')}
            placeholder={t('step2.personality.placeholder')}
            descriptionText={t('step2.personality.description')}
            value={props.personalityPrompt}
            onChange={(e) => props.onPersonalityPromptChange(e.target.value)}
            rows={12} // Taller for edit mode
            applyCustomScrollbar
          />
          {!props.isEditMode && props.onBasicKnowledgeChange && (
             <TextareaField
                label={t('step2.knowledge.basicKnowledge.label')}
                placeholder={t('step2.knowledge.basicKnowledge.placeholder')}
                descriptionText={t('step2.knowledge.basicKnowledge.description')}
                value={props.basicKnowledge || ''}
                onChange={(e) => props.onBasicKnowledgeChange!(e.target.value)}
                rows={10}
                applyCustomScrollbar
             />
          )}
        </div>
      </WizardStepCard>

      {!props.isEditMode && (
        <WizardStepCard titleKey="step2.knowledge.subheading" headerBgColor="bg-teal-100">
            <FeatureTeaser
                titleKey="teasers.knowledgeBase.title"
                descriptionKey="teasers.knowledgeBase.description"
            />
        </WizardStepCard>
      )}
    </>
  );
};